module.exports = __webpack_public_path__ + "img/reticule1.2158bf80.jpg";